import { ModalData } from '../../models';

import { UseContentSelector } from './UseContentSelector.ts';

export const ModalContent: UseContentSelector<ModalData | undefined, ModalData | undefined> = {
  useResultSelector: (content) => content.modal,
  useDataSelector: (modal) => modal,
};
